export default __webpack_public_path__ + "static/media/juice-fruit-product-l-mobile.83098ed7.png";